import { formatMoney } from '@debbie/common/dist/format-money.js';
import { useMoneyCalculatorItem } from '@debbie/cortex/dist/moneyCalculator/index.js';
import React from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import THEME from '../theme.js';
const Money = ({ amount, currency, className, color = false, scale = 'units', noCalculator = false, tooltip, }) => {
    const lang = useSelector((s) => s.lang);
    const calculator = useMoneyCalculatorItem(amount);
    const locale = lang.is.currently;
    const isScaled = scale !== 'units';
    const unit = currency != null && isScaled
        ? `${lang.financials.moneyScaleSuffixes.thousands}${currency}`
        : currency;
    const hover = tooltip ??
        (isScaled
            ? [formatMoney(locale, amount), currency].filter(Boolean).join(' ')
            : undefined);
    return (React.createElement(StyledMoney, { "data-tooltip-id": hover === undefined ? undefined : 'tooltip-top', "data-tooltip-content": hover, className: className, style: { opacity: calculator.isSelected ? 0.5 : 1 }, onClick: noCalculator ? undefined : calculator.toggle, $color: color, $amount: amount, $noCalculator: noCalculator },
        React.createElement("span", { className: "select-all" }, formatMoney(locale, amount, scale)),
        unit != null && unit !== '' && React.createElement("small", null,
            " ",
            unit)));
};
export default Money;
const StyledMoney = styled.span `
  cursor: ${(props) => (props.$noCalculator ? 'inherit' : 'pointer')};
  user-select: none;
  ${(props) => props.$color
    ? `color:  ${props.$amount > 0
        ? THEME.SUCCESS
        : props.$amount < 0
            ? THEME.DANGEROUS
            : ''}`
    : ''};

  small {
    opacity: 0.8;
    font-size: 0.7em;
  }
  .select-all {
    user-select: all;
  }
`;
//# sourceMappingURL=Money.js.map